import { render, staticRenderFns } from "./PrintOrderItems.vue?vue&type=template&id=0d705b02&scoped=true&"
import script from "./PrintOrderItems.vue?vue&type=script&lang=js&"
export * from "./PrintOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./PrintOrderItems.vue?vue&type=style&index=0&id=0d705b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d705b02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
